// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"252":"7db77942","448":"2af858ce","485":"8944c146","938":"cfd3372b"}[chunkId] + ".js";
};